import SettingsIcon from '@material-ui/icons/Settings';
import ViewListIcon from '@material-ui/icons/ViewList';
import PublishIcon from '@material-ui/icons/Publish';
import TimelineIcon from '@material-ui/icons/Timeline';
import GroupIcon from '@material-ui/icons/Group';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import TuneIcon from '@material-ui/icons/Tune';
import GetAppIcon from '@material-ui/icons/GetApp';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import ReceiptIcon from '@material-ui/icons/Receipt';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import DescriptionIcon from '@material-ui/icons/Description';


const mainNav = [
    {
        label: "tarifario",
        href: "/webdemo/principal/",
        idx: 0,
        disabled: false,
        sideNav: [            
            {
                title: 'Cálculo de tarifas',
                icon: <ViewListIcon/>,
                nav: [
                    {
                        label: "Consola de componentes",
                        href: "/webdemo/principal/consola-componentes",
                    },                      
                    {
                        label: "Opción tarifaria",
                        href: "/webdemo/principal/opcion-tarifaria",
                    },  
                    {
                        label: "Reliquidaciones",
                        href: "/webdemo/principal/reliquidaciones",
                    }, 
                    {
                        label: "Arbol tarifario",
                        href: "/webdemo/principal/arbol-tarifario",
                    },        
                    {
                        label: "Publicación",
                        href: "/webdemo/principal/publicar-tarifas",
                    },
                    {
                        label: "Alumbrado público",
                        href: "/webdemo/principal/alumbrado-publico",
                    },                        
                    
                ]
            },
            {
                title: 'Ajustes internos',
                icon: <SettingsIcon/>,
                nav: [
                    //  {
                    //     label: "Configuración principal",
                    //     href: "/webdemo/principal/administracion",                        
                    //  },
                    {
                        label: "Mercados",
                        href: "/webdemo/principal/mercados",
                    },
                    {
                        label: "Contratos de compra",
                        href: "/webdemo/principal/contratos-compra",
                    },
                    {
                        label: "Contratos de venta",
                        href: "/webdemo/principal/contratos-venta",
                    },
                    {
                        label: "Actores financieros",
                        href: "/webdemo/principal/actores-financieros",
                    },
                ]
            },
            {
                title: 'Insumos',
                icon: <PublishIcon/>,
                nav: [
                    {
                        label: "Archivos",
                        href: "/webdemo/principal/validacion-archivos",
                    },
                    {
                        label: "Parámetros",
                        href: "/webdemo/principal/validacion-parametros",
                    }
                ]
            },
            {
                title: 'Reportes',
                icon: <TimelineIcon/>,
                nav: [
                    {
                        label: "SUI",
                        href: "/webdemo/principal/reportes-sui",
                    }, 
                    {
                        label: "Informe comercialización",
                        href: "/webdemo/principal/informe-comercializacion",
                    },
                    {
                        label: "Balance energético",
                        href: "/webdemo/principal/balance-energetico",
                    },              
                    {
                        label: "Liquidación STR",
                        href: "/webdemo/principal/liquidacion-str",
                    },       
                ]
            },
            // {
            //     title: 'Componentes',
            //     icon: <ViewListIcon/>,
            //     nav: [
            //         {
            //             label: "Consola de estado",
            //             href: "/webdemo/principal/consola-componentes",
            //         },                    
            //     ]
            // }
        ]
    },
    {
            label: "facturador",
            href: "/webdemo/facturador/",
            idx: 1,
            disabled: false,
            sideNav: [   
                {
                    title: 'Parametrización',
                    icon:  <TuneIcon/>,
                    nav: [
                        {
                            label: "Ciclos",
                            href: "/webdemo/facturador/parametrizacion-ciclos",
                        },              
                        {
                            label: "Mensual",
                            href: "/webdemo/facturador/parametrizacion-mensual",
                        },  
                        {
                            label: "Anual",
                            href: "/webdemo/facturador/parametrizacion-anual",
                        },  
                        {
                            label: "Cuentas bancarias",
                            href: "/webdemo/facturador/parametrizacion-cuentas-bancarias",
                        },      
                        {
                            label: "Operadores de red",
                            href: "/webdemo/facturador/parametrizacion-operadores-de-red",
                        },          
                        {
                            label: "Conceptos",
                            href: "/webdemo/facturador/parametrizacion-conceptos",
                        },  
                        {
                            label: "Alumbrado público",
                            href: "/webdemo/facturador/parametrizacion-alumbrado-publico",
                        },   
                        {
                            label: "Impuesto de seguridad",
                            href: "/webdemo/facturador/parametrizacion-impuesto-seguridad",
                        },        
                    ]
                }, 
                {
                    title: 'Clientes',
                    icon:  <GroupIcon/>,
                    nav: [
                        {
                            label: "Control principal",
                            href: "/webdemo/facturador/control-principal-clientes",
                        },                                                          
                    ]
                }, 
                {
                    title: 'Consumos',
                    icon:  <AssessmentIcon/>,
                    nav: [
                        {
                            label: "Cargar información por ciclos",
                            href: "/webdemo/facturador/cargar-consumos-ciclo",
                        },       
                        {
                            label: "Información por cliente",
                            href: "/webdemo/facturador/informacion-consumos-cliente",
                        },                               
                    ]
                }, 
                {
                    title: 'Liquidación de consumos',
                    icon:  <LocalAtmIcon/>,
                    nav: [
                        {
                            label: "Liquidar",
                            href: "/webdemo/facturador/liquidar-consumos",
                        },                                                     
                    ]
                }, 
                {
                    title: 'Liquidación de impuestos',
                    icon:  <AccountBalanceIcon/>,
                    nav: [                   
                        {
                            label: "Alumbrado público",
                            href: "/webdemo/facturador/liquidar-alumbrado",
                        },    
                        {
                            label: "Impuesto de seguridad",
                            href: "/webdemo/facturador/liquidar-impuesto-seguridad",
                        },                                                  
                    ]
                }, 
                {
                    title: 'Liquidación otros conceptos/créditos',
                    icon:  <FeaturedPlayListIcon/>,
                    nav: [                          
                        {
                            label: "Cargar archivos",
                            href: "/webdemo/facturador/cargar-otros-conceptos",
                        },                                                  
                    ]
                }, 
                {
                    title: 'Facturación',
                    icon:  <ReceiptIcon/>,
                    nav: [
                        {
                            label: "Conceptos por cliente",
                            href: "/webdemo/facturador/conceptos-por-cliente",
                        }, 
                        {
                            label: "Generar facturas",
                            href: "/webdemo/facturador/generar-facturas",
                        },                                        
                    ]
                },
                {
                    title: 'Reportes',
                    icon:  <DescriptionIcon/>,
                    nav: [                   
                        // {
                        //     label: "Reportes internos",
                        //     href: "/webdemo/facturador/reportes-internos",
                        // },    
                        {
                            label: "Reportes SUI",
                            href: "/webdemo/facturador/reportes-sui",
                        },                                                  
                    ]
                },
                // {
                //     title: 'Autogeneradores',
                //     icon:  <AutorenewIcon/>,
                //     nav: [
                //         {
                //             label: "Cargar información",
                //             href: "/webdemo/facturador/cargar-info-agpe-gd",
                //         }, 
                //         {
                //             label: "Liquidar",
                //             href: "/webdemo/facturador/liquidar-agpe-dg",
                //         },                   
                //     ]
                // },         
            ]
    },    
    {
        label: "Autogeneradores",
        href: "/webdemo/autogeneradores/",
        idx: 2,
        disabled: false,
        sideNav: [            
            {
                title: 'Parametrización',
                icon:  <TuneIcon/>,
                nav: [          
                    {
                        label: "Ciclos",
                        href: "/webdemo/autogeneradores/parametrizacion-ciclos",
                    },                
                    {
                        label: "Precios pactados",
                        href: "/webdemo/autogeneradores/parametrizacion-precios-pactados",
                    },                              
                    {
                        label: "Conceptos",
                        href: "/webdemo/autogeneradores/parametrizacion-conceptos",
                    },   
                    {
                        label: "Causas no lectura",
                        href: "/webdemo/autogeneradores/parametrizacion-causas-no-lectura",
                    },                             
                ],
            },
            {
                title: 'Usuarios',
                icon:  <GroupIcon/>,
                nav: [
                    {
                        label: "Control principal",
                        href: "/webdemo/autogeneradores/usuarios",
                    },                                                          
                ]
            }, 
            {
                title: 'Consumos',
                icon:  <AssessmentIcon/>,
                nav: [
                    {
                        label: "Control de archivos",
                        href: "/webdemo/autogeneradores/control-archivos",
                    },   
                    {
                        label: "Información por cliente",
                        href: "/webdemo/autogeneradores/consumos-cliente",
                    },                                                      
                ]
            },
            {
                title: 'Liquidación de consumos',
                icon:  <LocalAtmIcon/>,
                nav: [
                    {
                        label: "Liquidar",
                        href: "/webdemo/autogeneradores/liquidacion-consumos",
                    },                                                     
                ]
            }, 
            {
                title: 'Exportar información',
                icon:  <GetAppIcon/>,
                nav: [
                    {
                        label: "Anexo para usuarios",
                        href: "/webdemo/autogeneradores/reporte-usuario",
                    },                                              
                ]
            },
            {
                title: 'Reportes internos',
                icon:  <TimelineIcon/>,
                nav: [
                    {
                        label: "Informe de facturación por archivo",
                        href: "/webdemo/autogeneradores/informe-facturacion",
                    },
                    {
                        label: "Tendencias",
                        href: "/webdemo/autogeneradores/tendencia-facturacion",
                    },                                                     
                ]
            },
            // {
            //     title: 'Información de energías',
            //     icon:  <TimelineIcon/>,
            //     nav: [
            //         {
            //             label: "Panel principal",
            //             href: "/webdemo/autogeneradores/consultas/panel-principal",
            //         },                                                                       
            //     ]
            // },
            // {
            //     title: 'Reportes facturación',
            //     icon:  <AssessmentIcon/>,
            //     nav: [
            //         {
            //             label: "Descargar anexo de factura",
            //             href: "/webdemo/autogeneradores/consultas/descargar-reporte",
            //         },                                                                       
            //     ]
            // },
            // {
            //     title: 'Pago de excedentes',
            //     icon:  <LocalAtmIcon/>,
            //     nav: [
            //         {
            //             label: "Estado",
            //             href: "/webdemo/autogeneradores/consultas/estado-pago-excedentes",
            //         },                                                                       
            //     ]
            // },
            // {
            //     title: 'Simulación',
            //     icon:  <GetAppIcon/>,
            //     nav: [
            //         {
            //             label: "Estimación de comportamiento",
            //             href: "/webdemo/autogeneradores/consultas/comportamiento-estimado",
            //         },                                                                       
            //     ]
            // },
        ]
    },

]

export default mainNav